// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32zF8","content":"styles_content__3CDCP"};